import { useState, useEffect } from "react";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export default function useWindowDimensions() {
  const [isDesktop, setIsDesktop] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  const DESKTOP_SIZE_START = 768;

  useEffect(() => {
    if (windowDimensions.width > DESKTOP_SIZE_START) {
      setIsDesktop(true);
    } else {
      setIsDesktop(false);
    }
  }, [windowDimensions]);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isDesktop;
}
